import * as React from "react";
import { useEffect, useRef, useState } from "react";

function useEmptyState(selector: string, onClose: (v: string) => void) {
  const input = useRef<HTMLInputElement | null>(null);
  const inputValue = useRef<string>("");
  const [currentValue, setCurrentValue] = useState("");

  // TODO: better outside click
  function outsideClick() {
    if (!input?.current) {
      return;
    }

    input.current.blur();
    document.body.click();
  }

  function close() {
    outsideClick();
  }

  function onKeyDown(e: KeyboardEvent) {
    if (e?.keyCode === 13) {
      outsideClick();
    }
  }

  function onValueChanged() {
    if (!input.current) {
      return;
    }
    inputValue.current = input.current.value;
    setCurrentValue(input.current.value);
  }

  useEffect(() => {
    input.current = document.querySelector(selector);
    if (!input.current) {
      return;
    }

    inputValue.current = input.current.value;
    setCurrentValue(input.current.value);

    input.current.addEventListener("input", onValueChanged);
    input.current.addEventListener("keydown", onKeyDown);

    return () => {
      if (!input.current) {
        return;
      }

      onClose(inputValue.current);
      input.current.removeEventListener("input", onValueChanged);
      input.current.removeEventListener("keydown", onKeyDown);
    };
  }, []);

  return {
    value: currentValue,
    close
  };
}


export interface IComboBoxEmptyStateProps {
  value: string;

  close(): void;
}

interface IEmptyState {
  selector: string;
  onCloseProp: (value: string) => void;
}

export function EmptyStateHOC(Component: React.ComponentType<IComboBoxEmptyStateProps>): React.ComponentType<IEmptyState> {
  return function EmptyStateHocInner({ selector, onCloseProp }: IEmptyState): JSX.Element {
    const { value, close } = useEmptyState(selector, onCloseProp);

    function onClose() {
      onCloseProp(value);
      close();
    }

    return <Component value={value} close={onClose} />;
  };
}